import { sortBy, startCase } from 'lodash';
import React, { FC } from 'react';
import styled from 'styled-components';
import { Filter } from 'components/molecules/filters/types';
import { FilterableField } from 'components/organisms/tasks/fields';
import { AdvancedFilterComponent } from 'components/organisms/tasks/filter-box/advanced';
import { Box, Row } from 'components/organisms/tasks/filter-box/components';
import { FilterType } from 'components/organisms/tasks/filter-box/filter-type';
import {
  GetFilterOperationTypeOptions,
  GetOperationOptionRenderer,
  GetSelectEditorComponents,
} from 'components/organisms/tasks/filter-box/utils';

export interface Props {
  addButtonText?: string;
  hideMatchTypeText?: boolean;
  showFilterType?: boolean;
  fields: FilterableField[];
  filter: Filter;
  onChange: (filter: Filter) => void;
  getFilterOperationTypeOptions?: GetFilterOperationTypeOptions;
  getSelectEditorComponents?: GetSelectEditorComponents;
  getOperationOptionRenderer?: GetOperationOptionRenderer;
}

const Header = styled(Row)`
  min-width: 500px;
`;

export const FilterBox: FC<Props> = ({
  addButtonText,
  hideMatchTypeText = false,
  showFilterType = true,
  fields,
  filter,
  onChange,
  getSelectEditorComponents,
  getFilterOperationTypeOptions,
  getOperationOptionRenderer,
}) => {
  const sorted = sortBy(
    fields,
    ({ fieldLabel, fieldName }) => fieldLabel ?? startCase(fieldName),
  );

  return (
    <Box className="filter-box">
      <Header>
        <FilterType
          value={filter.type}
          visible={showFilterType}
          onChange={(type) => onChange({ ...filter, type })}
        />
      </Header>
      <AdvancedFilterComponent
        addButtonText={addButtonText}
        hideMatchTypeText={hideMatchTypeText}
        fields={sorted}
        filter={filter}
        onChange={onChange}
        getFilterOperationTypeOptions={getFilterOperationTypeOptions}
        getSelectEditorComponents={getSelectEditorComponents}
        getOperationOptionRenderer={getOperationOptionRenderer}
      />
    </Box>
  );
};
